import {useContext} from "react";
import {AppContext} from "../../contexts/app-context";
import {
    usePlatformNewsReadState,
} from "./use-platform-news-read-state";

export function useCurrentUserPlatformNewsReadState() {
    const appContext = useContext(AppContext);
    const user = appContext.user;

    const userId = (
        user &&
        user.loggedIn &&
        user.info
    )
        ? user.info.id
        : null;

    const readState = usePlatformNewsReadState(userId);

    return {
        userId,
        ...readState,
    };
}
